"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlighter = void 0;
const react_1 = __importDefault(require("react"));
/**
 *
 * @param param0 The Props object
 * @param param0.search The search term to highlight
 * @param param0.text The full text
 * @param param0.caseSensitive Boolean that indicates if the search should be case sensitive
 * @returns The generated component
 */
const Highlighter = ({ search, text, caseSensitive, }) => {
    if (!search || !text) {
        return react_1.default.createElement(react_1.default.Fragment, null, text);
    }
    const chunks = text.split(new RegExp(`(${search})`, caseSensitive ? '' : 'i'));
    return (react_1.default.createElement(react_1.default.Fragment, null, chunks.map((chunk, index) => {
        if (chunk?.toLowerCase() !== search?.toLowerCase()) {
            return react_1.default.createElement("span", { key: index }, chunk);
        }
        return (react_1.default.createElement("strong", { key: index, style: { fontWeight: 'bolder', color: 'black' } }, chunk));
    })));
};
exports.Highlighter = Highlighter;
//# sourceMappingURL=highlighter.js.map